import React from "react";
import { Link } from "react-router-dom";
import "./Breadcrumb.css";

const Breadcrumb = ({ previousPageUrl, previousPageName, currentPageName }) => {

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-nav">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link
            to={previousPageUrl || `/${previousPageName
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
            className="breadcrumb-link"
          >
            {previousPageName}
          </Link>
        </li>

        <li className="breadcrumb-item active">
          <span className="breadcrumb-current">{currentPageName}</span>
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumb;
